export const AppPageTitlesEnum = {
    TL_HUB_INSTITUTION_LISTING: 'tick@lab - Institution Listing',
    GROUPS_LISTING: 'Colony Admin - Groups Listing',
    GROUPS_BULK_EDIT: 'Colony Admin - Fee Waivers Bulk Edit',
    GROUP_GENERAL_SETTINGS: 'Colony Admin - Group Settings',
    GROUP_MEMBERS: 'Colony Admin - Group Members',
    GROUPS_FEE_WAIVERS: 'Colony Admin - Groups Fee Waivers',
    GROUP_FEE_WAIVERS: 'Colony Admin - Group Fee Waivers',
};
